const KeyRegExps = {
  digit16: /^\d{4}-\d{4}-\d{4}-\d{4}$/,
  digit20: /^\d{4}-\d{4}-\d{4}-\d{4}-\d{4}$/,
  digit24: /^\d{4}-\d{4}-\d{4}-\d{4}-\d{4}-\d{4}$/
};

const LicenseKeyTypes = {
  VIEWER_PRO_ONLINE_LIC_CODE: '02',
  VIEWER_LITE_ONLINE_LIC_CODE: '05',
  VIEWER_PRO_EXTRA_FEATURES_ONLINE_LIC_CODE: '10',
  LICENSEPROXY_LIC_CODE: '03',
  VIEWER_OFFLINE_LIC_CODE: 'ZZ',
  VIEWER_PRO_OFFLINE_LIC_CODE: '00',
  VIEWER_LITE_OFFLINE_LIC_CODE: '04',
  PACS_OFFLINE_UNLIM_LIC_CODE: 'ZZ',
  PACS_OFFLINE_LIC_CODE: '00'
};

export const isLicenseKeyValid = (licenseKey, productName = null, type = null) => {
  let re = null;
  if (productName === 'viewer' || (productName === 'pacs_server' && type === LicenseKeyTypes.PACS_OFFLINE_UNLIM_LIC_CODE))
    re = KeyRegExps.digit16;
  else if (productName === 'pacs_server' && type === LicenseKeyTypes.PACS_OFFLINE_LIC_CODE)
    re = KeyRegExps.digit24;
  else
    re = KeyRegExps.digit20;
  return new RegExp(re).test(licenseKey);
}

export const isDeviceKeyValid = deviceKey => {
  return new RegExp(KeyRegExps.digit16).test(deviceKey);
}



// WEBPACK FOOTER //
// ./src/common/keyValidation.js